import random from 'lodash/random';

const WEDDING_COUNTDOWN_KEYS = {
  FIRST_TIME_USER: 'FIRST_TIME_USER',
  NO_WEDDING_DATE: 'NO_WEDDING_DATE',
  GREATER_THAN_YEAR_OUT: 'GREATER_THAN_YEAR_OUT',
  NINETY_DAYS_TO_YEAR_OUT: '90_360_DAYS_OUT',
  THIRTY_TO_NINETY_DAYS_OUT: '30_90_DAYS_OUT',
  ZERO_TO_THIRTY_DAYS_OUT: '0_30_DAYS_OUT',
  PAST_WEDDING_DATE: 'PAST_WEDDING_DATE',
};

export const CHECKLIST_HEADER_COPY_MAP = {
  [WEDDING_COUNTDOWN_KEYS.FIRST_TIME_USER]: [
    (firstName, partnerFirstName) => `Welcome ${firstName}, ${partnerFirstName}!`,
  ],
  [WEDDING_COUNTDOWN_KEYS.NO_WEDDING_DATE]: [
    'Bring on the matrimony!',
    'You two are #CoupleGoals.',
    "What's it like being so awesome?",
    "You're getting married! How cool is that?",
    "You're engaged! That's reason enough to celebrate.",
    'Let the good times roll.',
    'We hope you feel warm and fuzzy today (and every day).',
    "It's never too early to daydream about wedding cake.",
    "Psst. Psssst. You two rock. That's all. Carry on.",
    'We have a good feeling about today.',
  ],
  [WEDDING_COUNTDOWN_KEYS.GREATER_THAN_YEAR_OUT]: [
    'Spoiler alert: Your wedding is going to be EPIC.',
    "Hey, you. You're doing great, you know that?",
    'When in doubt: caffeinate.',
    'You two are really cute together.',
    'Amazing things are coming your way.',
    'Daydreaming about your big day? Same here.',
    "You're unstoppable today!",
    'You two make the best team.',
    'This is going to be a great year.',
    'Another day closer to the best day ever.',
  ],
  [WEDDING_COUNTDOWN_KEYS.NINETY_DAYS_TO_YEAR_OUT]: [
    (firstName, partnerFirstName) => `Planning looks good on you, ${firstName} & ${partnerFirstName}.`,
    'Breathe in, hold. Breathe out, repeat. You got this.',
    "Woo hoo! You're kicking wedding planning's butt!",
    'We have a good feeling about today.',
    'Celebrate the small wins today and every day.',
    'The best part of wedding planning? All the snack breaks.',
    'Keep calm and plan on.',
    'Things that spark joy: Puppies. Cake. Your wedding vision.',
    "You're unstoppable today!",
    "You've got this.",
  ],
  [WEDDING_COUNTDOWN_KEYS.THIRTY_TO_NINETY_DAYS_OUT]: [
    'Is it time to cut the wedding cake yet?',
    'You deserve a massage… or ten.',
    'Another day closer to the best day ever.',
    "You're making magic happen!",
    'Take a minute to breathe today. Everything is figure-outable.',
    'You two are crushing your wedding planning.',
    'Repeat after us: We can do this. We. Can. Do. This.',
    'Hey, can we bring a plus one to your wedding? Kidding.',
    'Whoa, you two are on a roll!',
    'Woo hoo! Look at you plowing through.',
  ],
  [WEDDING_COUNTDOWN_KEYS.ZERO_TO_THIRTY_DAYS_OUT]: [
    "You're in the homestretch!",
    'So close we can taste your wedding cake. Yum.',
    "It's alllll coming together...",
    'Treat yourself today. You deserve it.',
    'Getting (really, really, really) excited? Same here.',
    "You're almost done planning a whole. entire. wedding.",
    'The final countdown!',
    "No need to pinch yourselves. It's all actually happening!",
    'Can you plan our wedding?',
    'You can do this. You. Can. Do. This.',
  ],
  [WEDDING_COUNTDOWN_KEYS.PAST_WEDDING_DATE]: [
    'Cheers to your next chapter!',
    (firstName, partnerFirstName) => `Congrats, ${firstName} & ${partnerFirstName}!`,
    'Wishing you all the best on your newlywed adventure.',
    'Can we come on your honeymoon? Kidding.',
    'Is there any cake left? Asking for a friend...',
    'The best is yet to come!',
    'Woo hoo! You did it!',
    'Your wedding was EPIC.',
    'You came. You saw. You conquered (wedding planning).',
    'Thanks for letting us be part of your wedding!',
  ],
};

export const getDaysTillWeddingDateKey = (daysTillWedding) => {
  switch (true) {
    case daysTillWedding > 365: {
      return WEDDING_COUNTDOWN_KEYS.GREATER_THAN_YEAR_OUT;
    }
    case daysTillWedding > 90 && daysTillWedding <= 365: {
      return WEDDING_COUNTDOWN_KEYS.NINETY_DAYS_TO_YEAR_OUT;
    }
    case daysTillWedding > 30 && daysTillWedding <= 90: {
      return WEDDING_COUNTDOWN_KEYS.THIRTY_TO_NINETY_DAYS_OUT;
    }
    case daysTillWedding >= 0 && daysTillWedding <= 30: {
      return WEDDING_COUNTDOWN_KEYS.ZERO_TO_THIRTY_DAYS_OUT;
    }
    case daysTillWedding < 0: {
      return WEDDING_COUNTDOWN_KEYS.PAST_WEDDING_DATE;
    }
    default: {
      return WEDDING_COUNTDOWN_KEYS.NO_WEDDING_DATE;
    }
  }
};

export const getRandomHeaderMessage = (daysTillWedding, isNewChecklistUser) => {
  const key = isNewChecklistUser ? WEDDING_COUNTDOWN_KEYS.FIRST_TIME_USER : getDaysTillWeddingDateKey(daysTillWedding);
  const messages = CHECKLIST_HEADER_COPY_MAP[key];

  return messages[random(0, messages.length - 1)];
};

export const getHeaderCopy = ({ daysTillWedding, isFirstTimeChecklistUser, firstName, partnerFirstName }) => {
  let message = getRandomHeaderMessage(daysTillWedding, isFirstTimeChecklistUser);

  // if a function is returned, interpolate first name of user/partner
  if (typeof message === 'function') {
    message = message(firstName, partnerFirstName);
  }

  return message;
};

export default {
  WEDDING_COUNTDOWN_KEYS,
  CHECKLIST_HEADER_COPY_MAP,
  getRandomHeaderMessage,
  getDaysTillWeddingDateKey,
  getHeaderCopy,
};



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistHeader/helpers.js